import { gql } from '@apollo/client';

import { initialStates } from '@trqk/resolvers';

const { session, uiState } = initialStates;

export const initialStateData = {
    proIngestions: [] as PROIngestion[],
    session: { ...session },
    uiState: { ...uiState },
    users: [] as User[],
};

// Note that any saved queries such as packages/resolvers/src/uiState/getUiState.ts must be
// kept in sync with the shape of this state.
export const INITIAL_STATE = gql`
    query initialState {
        proIngestions {
            id
        }
        session {
            token
            codeDeliveryDetails
            currentUser
            expiration
            isSigningUp
            issuedAt
            sessionIsValid
        }
        uiState {
            currentlyPlayingAudio
            detections {
                showChart
            }
            logPollingInterval
            statements {
                displayMode
                showUploadHasStarted
                statementId
                unviewedStatements
            }
            tracks {
                viewUnmatchedTracksOnly
            }
        }
        users {
            id
        }
    }
`;
